import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  uploadVisitProofApi,
  getVisitProofsApi,
  deleteVisitProofApi
} from "../../services/visitProofApi";

const VisitProofs = () => {
  const { activityId } = useParams(); // ✅ FIXED

  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  // ===============================
  // FETCH PROOFS
  // ===============================
  const fetchImages = async () => {
    try {
      const res = await getVisitProofsApi(activityId);
      setImages(res.data.images || []);
    } catch (err) {
      console.log(err);
      setImages([]);
    }
  };

  useEffect(() => {
    if (activityId) fetchImages();
  }, [activityId]);

  // ===============================
  // HANDLE UPLOAD
  // ===============================
  const handleUpload = async () => {
    if (!files.length) return alert("Select images first");

    const formData = new FormData();
    formData.append("activity_id", activityId);

    files.forEach((file) => {
      formData.append("images", file);
    });

    try {
      setLoading(true);
      await uploadVisitProofApi(formData);
      alert("Uploaded successfully");
      setFiles([]);
      fetchImages();
    } catch (err) {
      alert(err?.response?.data?.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // DELETE
  // ===============================
  const handleDelete = async (id) => {
    try {
      await deleteVisitProofApi(id);
      fetchImages();
    } catch (err) {
      alert("Delete failed");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📸 Visit Proofs</h2>

      {/* UPLOAD */}
      <input
        type="file"
        multiple
        onChange={(e) => setFiles([...e.target.files])}
      />

      <button onClick={handleUpload} disabled={loading}>
        Upload
      </button>

      {/* LIST */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 20 }}>
        {images.map((img) => (
          <div key={img.id}>
            <img
              src={`${img.image_url}`}
              width="120"
              alt=""
            />
            <button onClick={() => handleDelete(img.id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisitProofs;